import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8 .875a7.125 7.125 0 1 1 0 14.25A7.125 7.125 0 0 1 8 .875zm2.83 3.237L8 6.942l-2.83-2.83L4.112 5.17 6.942 8l-2.83 2.83 1.058 1.058L8 9.058l2.83 2.83 1.058-1.058L9.058 8l2.83-2.83-1.058-1.058z",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }